<template>
  <v-snackbar v-model="error.show" :bottom="true" :multi-line="true" color="red darken-3">
    <span class="subtitle-1">
      {{ error.message }}
    </span>
    <v-btn color="primary" @click="close" class="close-btn">Ok</v-btn>
  </v-snackbar>
</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'ErrorAlert',
  computed: mapState(['error']),
  methods: {
    close() {
      this.$store.commit('clearError', false)
    }
  }
}
</script>
